import styles from "../../styles/Work.module.scss";
const WorkTitle = ({title}) => {
  return <h6 className={styles.worktitle}>{title}</h6>;
};

export default WorkTitle;
